// tienda/CoberturaSection.jsx

import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, Clock, HandCoins, MapPinned, Truck } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";
import { CoverageList } from "./CoverageList";
import { MapMockup } from "./MapMockup";

const KPIS = [
  { label: "Lima same-day", value: "50 distritos", icon: <Truck className="size-4" />, color: brand.primary },
  { label: "Corte tienda", value: "12:00 PM", icon: <Clock className="size-4" />, color: brand.accentGold },
  { label: "Corte Provider", value: "2:00 PM", icon: <CheckCircle2 className="size-4" />, color: brand.accentGreen },
  { label: "Todo Perú", value: "Olva y Shalom", icon: <MapPinned className="size-4" />, color: brand.plum },
];

export function CoberturaSection() {
  return (
    <section id="cobertura" className="border-b bg-white scroll-mt-16" style={{ borderColor: brand.line }}>
      <div className="mx-auto max-w-7xl px-4 py-14 md:py-20">
        <motion.div {...fadeUp} className="mb-10 grid gap-5 md:grid-cols-[0.9fr_1.1fr] md:items-end">
          <div>
            <p className="mb-3 text-xs font-black uppercase tracking-[0.2em]" style={{ color: brand.primary }}>
              Cobertura
            </p>
            <h2 className="text-3xl font-black md:text-4xl" style={{ color: brand.ink }}>
              Same-day en Lima y fulfillment para todo el Perú.
            </h2>
          </div>
          <p className="text-sm leading-relaxed md:text-base" style={{ color: brand.muted }}>
            Nuestra operación principal está en Lima y Callao para entregas el mismo día.
            Para ventas fuera de Lima, preparamos tus pedidos desde fulfillment Fast Max
            y despachamos a todo el Perú con Olva y Shalom.
          </p>
        </motion.div>

        <div className="grid gap-6 lg:grid-cols-[1fr_0.9fr] lg:items-start">
          <motion.div {...fadeUp} className="overflow-hidden rounded-2xl border bg-white shadow-sm" style={{ borderColor: brand.line }}>
            <div className="grid gap-0 md:grid-cols-2">
              <div className="relative min-h-[300px] md:min-h-[360px]">
                <MapMockup />
              </div>
              <div className="p-5">
                <div className="grid grid-cols-2 gap-3">
                  {KPIS.map(kpi => (
                    <div key={kpi.label} className="rounded-2xl border bg-white p-3" style={{ borderColor: brand.line }}>
                      <span className="mb-3 grid size-9 place-items-center rounded-xl" style={{ background: `${kpi.color}14`, color: kpi.color }}>
                        {kpi.icon}
                      </span>
                      <div className="text-[11px] font-semibold" style={{ color: brand.muted }}>{kpi.label}</div>
                      <div className="mt-1 text-sm font-black" style={{ color: brand.ink }}>{kpi.value}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-4 rounded-2xl border p-4" style={{ borderColor: brand.line, background: brand.bg }}>
                  <div className="mb-2 flex items-center gap-2">
                    <HandCoins className="size-4" style={{ color: brand.primary }} />
                    <p className="text-sm font-black" style={{ color: brand.ink }}>Contraentrega en Lima</p>
                  </div>
                  <p className="text-xs leading-relaxed" style={{ color: brand.muted }}>
                    COD y seguimiento en vivo aplican para la operación urbana de Lima.
                    En provincias coordinamos despacho nacional desde almacén.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <CoverageList />
        </div>
      </div>
    </section>
  );
}
